<template>
  <div
    class="mb-3"
    data-aos="fade-in"
    data-aos-easing="ease-in-out"
    data-aos-duration="500"
  >
    <div class="grid xl:grid-cols-2 gap-x-5 grid-cols-1 gap-y-5 mt-3">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "FormContainer",
};
</script>
